<template>
    <div>
        <title-divider :title="variableTitle"></title-divider>

        <div class="col-xs-12 div-btns-categories">
                <horizontal-data-list-component
                    ref="data_list"
                    :data-source="urlCategories" class="horizontal-data-list-component">
                    <template slot-scope="slotData">
                        <button
                            class="btn-category"
                            @click="changeCategoryId(0, 'Todas as campanhas')"
                            :id="'category_' + 0">
                            TODAS
                        </button>
                        <template v-for="(category, index) in slotData.items">
                            <button
                                class="btn-category"
                                @click="changeCategoryId(category.id, category.name)"
                                :id="'category_' + category.id">
                                {{category.name}}
                            </button>
                        </template>
                    </template>
                </horizontal-data-list-component>
        </div>
    </div>
</template>
<script>

    import TitleDivider from '@/components/TitleDivider.vue';

    export default {
      name: 'categories',

        components: {
            TitleDivider
        },

      props: {
        title: String,
        categoryId: String,
        product_type_id: {
          type: Number,
          required: true
        },
        urlCategories: String,
        url_search: String,
      },

      mounted() {
        $('.btn-category').removeClass('selected');
        this.fetchTemplates(this.categoryId);

        axios.get(this.urlCategories).then(response => {
            let categories = response.data.data;
            var vm = this;
            categories.forEach(function (category) {
                if (vm.categoryId == category.id) {
                    return vm.changeCategoryId(category.id, category.name);
                }
            })
        })
      },

      watch: {
        category_id(category_id) {
            this.fetchTemplates(category_id);
        },
      },

      data() {
        return {
          category_id: undefined,
          variableTitle: this.title
        }
      },

      methods: {
        fetchTemplates(category_id) {
          const url =  this.url_search.replace(':category_id', category_id);
          this.$root.$emit('setBundles', url);
        },

        changeCategoryId(categoryId, categoryName) {
          $('.btn-category').removeClass('selected');
            this.category_id = categoryId;
            $('#category_' + categoryId).addClass('selected');
            return this.variableTitle = categoryName;
        }
      },
    }
</script>
<style scoped>
    button:hover {
        background-color: #f1f1f1;
    }

    .selected {
        background-color: #ffffff;
        border: 2px solid #ED1763;
        font-weight: bold;
    }

    .btn-category:hover {
        border: 2px solid #ED1763;
    }

    button {
        padding: 4px 8px;
        border-radius: 6.79px;
        background-color: white;
        outline:none;
        border: 1px solid #bfbfbf;
        margin: 10px;
    }

    .div-btns-categories {
        text-align: center;
    }

    .main-content {
        display: inline-block;
        width: 100%;
        padding: 15px;
    }

    @media (max-width: 768px) {
        button {
            width: 125px;
            font-size: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/store/components/Categories.vue